import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import classBookingService from "services/classBooking.service";
import { formatSessionStart } from "pages/setting/List/classSessionForm";

// Class seats live in their own store, so the client's appointment history
// shows them as a separate section. Cancelled seats stay listed so the client
// history is complete, but they are marked as cancelled.
const ClientClassBookings = () => {
  const { t } = useTranslation();
  const detail = useSelector((state) => state.client.isDetailData);
  const clientId = detail && detail.id;
  const [result, setResult] = useState({clientId: null, bookings: []});
  const bookings = String(result.clientId) === String(clientId) ? result.bookings : [];
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    setResult({clientId, bookings: []});
    if (!clientId) { setLoading(false); return undefined; }
    setLoading(true);
    classBookingService
      .salonClassBookings({ client_id: clientId, include_cancelled: true })
      .then((response) => {
        if (!active) return;
        const payload = (response && response.data) || {};
        setResult({clientId, bookings: Array.isArray(payload.bookings) ? payload.bookings : []});
      })
      .catch(() => { if (active) setResult({clientId, bookings: []}); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [clientId]);

  if (!loading && bookings.length === 0) return null;

  return (
    <div className="content-wrp mt-3" data-testid="client-class-bookings">
      <h5 className="mb-3">{t("Class bookings")}</h5>
      {loading && <p className="text-muted">{t("Loading...")}</p>}
      <ul className="list-unstyled m-0 p-0">
        {bookings.map((item) => (
          <li key={item.id} className="border rounded p-3 mb-2 d-flex justify-content-between align-items-center">
            <div>
              <h6 className="mb-1">{item.session ? item.session.name : t("Class")}</h6>
              <small className="text-muted">
                {formatSessionStart(item.session && item.session.start_at)}
              </small>
            </div>
            <span className={item.status === "cancelled" ? "text-danger" : "text-success"}>
              {item.status === "cancelled" ? t("Cancelled") : t("Booked")}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ClientClassBookings;
